import React, { Component, Fragment } from 'react';
import Breadcrumbs from '@material-ui/core/Breadcrumbs';
import Typography from '@material-ui/core/Typography';
import { emphasize } from '@material-ui/core/styles';
import { Link } from 'react-router-dom';
import { StyleSheet, css } from 'aphrodite';
import { AppTheme } from '../../styles/AppTheme';
import { CustomBreadCrumbsStyles } from '../../styles/CustomStyles';
import { AppConfig } from '../../AppConfig';
import { Controller } from '../Controller';
import { Helper } from '../helpers/Helper';
import { AppHelper } from '../../helpers/AppHelper';
let Styles = {}
export class BreadCrumbs extends Component {
  constructor(props) {
    super(props);
  }
  getRoute(item) {
    if(item.title !== Helper.getString('home') || !item.to) {
      return item.to
    }
    const orgId = AppHelper.parseOrgId(item.to)
    if(!orgId) {
      return Controller.get().getHomeByRole()
    }
    return Controller.get().getHomeByRole(Controller.get().roleHelper().getOrgUnitId(orgId))
  }
  render() {
    if (!this.props.breadCrumbs || this.props.breadCrumbs.length === 0) {
      return ''
    }

    return (
      <Breadcrumbs aria-label='Breadcrumb' className={css(Styles.breadCrumbsContainer)}>
        {this.props.breadCrumbs.map((item, index) => {
          const last = (index === this.props.breadCrumbs.length - 1);
          return (!('to' in item) && !('onClick' in item)) ?
            <Typography
              className={css(Styles.lastTextStyle)}
              key={index}>
              {item.title}
            </Typography>
            :
            <Link to={this.getRoute(item)} onClick={item.onClick} key={index} className={css(Styles.link)}>
              <Typography
                className={css(item.type === 'button' ? Styles.textStyleButton : Styles.textStyle)}
                key={index}>
                {item.icon && <i className='material-icons-outlined' style={{ fontSize: 14, color: AppTheme.buttonTextColor,marginRight: 2 }}>{item.icon}</i>}
                {item.title}
              </Typography>
            </Link>
        })}
      </Breadcrumbs>
    );
  }

}

Styles = AppConfig.CUSTOM_STYLE ? CustomBreadCrumbsStyles : StyleSheet.create({
  textStyle: {
    //backgroundColor: AppTheme.primaryColor,
    //padding: '2px 12px',
    color: 'grey',
    fontSize: 18,
    textTransform: 'capitalize',
    borderRadius: 12,
    '&:hover, &:focus': {
      //backgroundColor: AppTheme.primaryColor,
      cursor: 'pointer'
    },
    '&:active': {
      //backgroundColor: emphasize(AppTheme.primaryColor),
    },
  },
  lastTextStyle: {
    color: 'grey',
    fontSize: 18,
    textTransform: 'capitalize'
  },
  link: {
    textDecoration: 'none'
  },
  textStyleButton: {
    textDecoration: 'none',
    backgroundColor: AppTheme.buttonBg,
    color: AppTheme.buttonTextColor,
    padding: '2px 10px',
    borderRadius: 18,
    fontSize: 14,
    textTransform: 'capitalize'
  }
})
